module.exports = __webpack_public_path__ + "img/partner32.9a56f803.png";